import useSWR from 'swr'
import { fetchFamilyStock } from '@api/backendCatalog/fetchFamilyStock'
import trackError from '@helpers/trackError'
import { BackendColourwayStock, BackendStockKey } from 'types/backendPdp'

// The colourway's entry in the backend's live stock response, or undefined
// while it loads, when the request fails or 404s, or when the handle has no
// backend colourway. Undefined always means "behave as today", so the page
// never waits on this. One request per family, cached by SWR, so switching
// colour within a family doesn't refetch.
export default function useColourwayStock(
  stockKey: BackendStockKey | undefined
): BackendColourwayStock | undefined {
  const familySlug = stockKey?.familySlug

  const { data: stock } = useSWR(
    familySlug ? ['backend-family-stock', familySlug] : null,
    () => fetchFamilyStock(familySlug as string),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      onError: error => {
        trackError(new Error('Failed to fetch backend family stock'), {
          error: error as Error,
          section: 'PDP',
          familySlug
        })
      }
    }
  )

  if (!stock || !stockKey) return undefined

  return stock[stockKey.handle]
}
